export default {
    methods: {
        normalizeOperator(value, fallback) {
            if (!value) {
                return fallback
            }
            const normalized = String(value).toUpperCase()
            if (['GT', 'GTE', 'LT', 'LTE'].includes(normalized)) {
                return normalized
            }
            if (value === '>' || value === '>=') {
                return value === '>' ? 'GT' : 'GTE'
            }
            if (value === '<' || value === '<=') {
                return value === '<' ? 'LT' : 'LTE'
            }
            return fallback
        },
        formatOperatorSymbol(value, fallback) {
            const op = this.normalizeOperator(value, fallback)
            const map = {
                GT: '>',
                GTE: '>=',
                LT: '<',
                LTE: '<=',
            }
            return map[op] || map[fallback] || fallback
        },
        normalizeNumber(value) {
            if (value === null || value === undefined || value === '') {
                return null
            }
            const parsed = Number(value)
            return Number.isNaN(parsed) ? null : parsed
        },
        formatWeightRangeWithOperators(from, to, fromOperator, toOperator, unit) {
            const parsedFrom = this.normalizeNumber(from)
            const parsedTo = this.normalizeNumber(to)
            const fromOp = this.formatOperatorSymbol(fromOperator, 'GTE')
            const toOp = this.formatOperatorSymbol(toOperator, 'LTE')
            const suffix = unit || '% (w/w)'
            if (parsedFrom === null && parsedTo === null) {
                return '-'
            }
            if (parsedFrom !== null && parsedTo !== null) {
                if (parsedFrom === parsedTo) {
                    return `${fromOp} ${parsedFrom} ${suffix}`
                }
                return `${fromOp} ${parsedFrom} - ${toOp} ${parsedTo} ${suffix}`
            }
            if (parsedFrom !== null) {
                return `${fromOp} ${parsedFrom} ${suffix}`
            }
            return `${toOp} ${parsedTo} ${suffix}`
        },
        formatWeightRange(from, to) {
            const parsedFrom = this.normalizeNumber(from)
            const parsedTo = this.normalizeNumber(to)
            if (parsedFrom === null && parsedTo === null) {
                return '-'
            }
            if (parsedFrom !== null && parsedTo !== null) {
                if (parsedFrom === parsedTo) {
                    return String(parsedFrom)
                }
                return `${parsedFrom} - ${parsedTo}`
            }
            return String(parsedFrom !== null ? parsedFrom : parsedTo)
        },
        parseWeightInput(value) {
            if (value === null || value === undefined) {
                return { from: null, to: null }
            }
            const raw = String(value).trim()
            if (!raw) {
                return { from: null, to: null }
            }
            const normalized = raw
                .replace(/–|—/g, '-')
                .replace(/,/g, '.')
                .replace(/\s+/g, ' ')
            const match = normalized.match(/^(\d+(?:\.\d+)?)(?:\s*-\s*(\d+(?:\.\d+)?))?$/)
            if (!match) {
                return { from: null, to: null }
            }
            const from = this.normalizeNumber(match[1])
            const to = this.normalizeNumber(match[2] !== undefined ? match[2] : match[1])
            return { from, to }
        },
    },
}
